export default Object.freeze({
  /**
   * 토큰 갱신
   */
  "/auth/refresh": {
    path: "/app/{0}/cafe24/{1}/auth/refresh",
    method: "GET",
  },
  /**
   * 멤버십 이용 현황 조회
   */
  "/get/membership/usage": {
    path: "/app/{0}/mall/{1}/api/membership/usage",
    method: "GET",
  },
  /**
   * 멤버십 매출 현황 조회
   */
  "/get/membership/sales": {
    path: "/app/{0}/mall/{1}/api/membership/sales",
    method: "GET",
  },

  /**
   * 멤버십 리스트 조회
   */
  "/get/membership/list": {
    path: "/app/{0}/mall/{1}/api/membership",
    method: "GET",
  },

  /**
   * 멤버십 개별 조회
   */
  "/get/membership": {
    path: "/app/{0}/mall/{1}/api/membership/{2}",
    method: "GET",
  },
  /**
   * 현재 사용중 회원 수 조회
   */
  "/get/membership/members/count": {
    path: "/app/{0}/mall/{1}/api/membership/:membership_id/members/count",
    method: "GET",
  },
  /**
   * 멤버십 등록
   */
  "/post/membership": {
    path: "/app/{0}/mall/{1}/api/membership",
    method: "POST",
  },
  /**
   * 멤버십 수정
   */
  "/put/membership": {
    path: "/app/{0}/mall/{1}/api/membership/{2}",
    method: "PUT",
  },
  /**
   * 카페24 상품 리스트 조회
   */
  "/get/membership/products/search": {
    path: "/app/{0}/mall/{1}/api/membership/products/search",
    method: "GET",
  },
  /**
   * 멤버십 상품리스트 조회
   */
  "/get/membership/products": {
    path: "/app/{0}/mall/{1}/api/membership/products",
    method: "GET",
  },
  /**
   * 멤버십 상품 등록
   */
  "/post/membership/products": {
    path: "/app/{0}/mall/{1}/api/membership/products",
    method: "POST",
  },
  /**
   * 멤버십 상품 삭제
   */
  "/delete/membership/products": {
    path: "/app/{0}/mall/{1}/api/membership/products/{2}",
    method: "DELETE",
  },
  /**
   * 카페24 쿠폰 리스트 조회
   */
  "/get/membership/coupons": {
    path: "/app/{0}/mall/{1}/api/membership/coupons",
    method: "GET",
  },
  /**
   * 멤버십 쿠폰 리스트 조회
   */
  "/get/membership/coupon": {
    path: "/app/{0}/mall/{1}/api/membership/coupon",
    method: "GET",
  },
  /**
   * 멤버십 쿠폰 등록
   */
  "/post/membership/coupon": {
    path: "/app/{0}/mall/{1}/api/membership/coupon",
    method: "POST",
  },
  /**
   * 멤버십 쿠폰 삭제
   */
  "/delete/membership/coupon": {
    path: "/app/{0}/mall/{1}/api/membership/coupon/{2}",
    method: "DELETE",
  },

  /**
   * 카페24 쿠폰 조회
   */
  "/get/membership/coupons/detail": {
    path: "/app/{0}/mall/{1}/api/membership/coupons/{2}",
    method: "GET",
  },
});
